import React from "react";

export const ResultFeedback = () => {
    return (
        <>
            <div className="sb-result-feedback">
                <h3>Feedback</h3>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</p>

            </div>
        </>
    )
}